module.exports = __webpack_public_path__ + "static/media/Gary Waymire.ade08e28.png";